import { useEffect, useState, type ImgHTMLAttributes } from "react";
import { apiBlob, CLIENT } from "../api";

/**
 * <img> for API-served private images (customer photos, logo, payment QR). In the browser the session cookie does the
 * job; the native app has no cookie (bearer token) and runs on another origin, so it fetches the bytes with the token
 * and shows a blob: URL.
 */
export function AuthImage({ src, ...rest }: ImgHTMLAttributes<HTMLImageElement> & { src: string }) {
  const [url, setUrl] = useState<string | null>(CLIENT === "native" && src.startsWith("/") ? null : src);
  useEffect(() => {
    if (CLIENT !== "native" || !src.startsWith("/")) { setUrl(src); return; }
    let obj: string | null = null, live = true;
    apiBlob(src).then((b) => { if (!live) return; obj = URL.createObjectURL(b); setUrl(obj); }).catch(() => undefined);
    return () => { live = false; if (obj) URL.revokeObjectURL(obj); };
  }, [src]);
  return url ? <img src={url} {...rest} /> : <span className="img-placeholder" aria-hidden style={{ display: "inline-block", width: rest.width ?? 48, height: rest.height ?? 48 }} />;
}
